'use client'

import { useEffect, useRef, useState } from "react";
import styles from "./ua.module.scss";
import Button from "../button/Button";
import ColorButton from "./ColorButton";
import { genInvUrl, getFiltersFromParams } from "@/data/Inventory";
import BrandButton from "./BrandButton";
import MileageButton from "./MileageButton";
import Icon from "../icon/Icon";
import { formatCurrency, formatNumber } from "@/utils/Formatters";
import VehicleTypeButton from "./VehicleTypeButton";
import Pill from "../pills/Pill";
import SearchField from "@/partials/vehicles/SearchField";
import PreOwnedButton from "./PreOwnedButton";
import useEventListener from "../plugins/EventListener";
import FuelButton from "./FuelButton";
import Field from "../form/Field";
import Form from "../form/Form";
import ModelButton from "./ModelButton";

export const VEHICLE_TYPES = {
  'suv': 'SUV',
  'truck': 'Truck',
  'sedan': 'Sedan',
  'crossover': 'Crossover',
  'coupe': 'Coupe',
  'sport': 'Sport',
  'minivan': 'Minivan',
  'hatchback': 'Hatchback',
  'convertible': 'Convertible',
}

const sortOptions = [
  { id: 'price', label: 'Price: low to high' },
  { id: 'price-desc', label: 'Price: high to low' },
  { id: 'location', label: 'Closest to me' },
]

export default function FiltersComponent(props) {
  
  const filterPills = ['term','condition','brand','body','max_miles','max_price','year','did','color','fuel','model']

  const filterBar = useRef()
  const [leftEdge,setLeftEdge] = useState(false)
  const [rightEdge,setRightEdge] = useState(false)
  const [ddVisible,setDdVisible] = useState(false)
  const [sortOrder,setSortOrder] = useState(props.filters?.sort ? props.filters?.sort[0] : 'price')
  
  const filters = props.filters
  
  const [pillsVisible,setPillsVisible] = useState(false)

  useEventListener("dd_visible", event => {
    setDdVisible(event.detail)
  })

  useEffect(() => {
    if (filterBar) {
      if (filterBar.current.scrollLeft + filterBar.current.offsetWidth >= filterBar.current.scrollWidth) {
        setRightEdge(false)
      } else {
        setRightEdge(true)
      }
    }
  }, [])
  
  const vehTypes = props.site.inventory.topFilters?.vehicleTypes?.map((item) => {
    return { key: item, icon: 'veh-type-' + item, label: VEHICLE_TYPES[item], link: "/vehicles/" + item }
  })

  const isFilterByCondition = (condition) => {
    return filters.condition && filters.condition.indexOf(condition) >= 0
  }
  
  const isFilterByBodyType = (type) => {
    return filters.body && filters.body.indexOf(type) >= 0
  }
  
  const genUrl = (item, selected) => {
    let filterParams = Object.assign({}, props.filters)
    if (props.hideBudgetButton) delete filterParams['max_price']
    return genInvUrl(filterParams, item, selected)
  }
  
  const showPills = () => {
    if (filterCount() > 0) {
      setPillsVisible(!pillsVisible)
    }
  }
  
  const removeFilter = (param) => {
    if (Array.isArray(filters[param.key])) {
      if (Array.isArray(param.value)) {
        param.value.map(v => {
          const i = filters[param.key].indexOf(v)
          if (i >= 0) filters[param.key].splice(i, 1)
        })
      } else {
        const i = filters[param.key].indexOf(param.value)
        if (i >= 0) filters[param.key].splice(i, 1)
      }
      props.listingRef.current.applyFilters({ clear: true, [param.key]: filters[param.key].length > 0 ? filters[param.key] : null })
    } else {
      props.listingRef.current.applyFilters({ clear: true, [param.key]: null })
    }
    if (filterCount() == 0) {
      setPillsVisible(false)
    }
  }
  
  const onClick = (params) => {
    if (props.local) {
      props.listingRef.current.applyFilters(params)
    }
  }

  const onScroll = (e) => {
    if (e.target.scrollLeft > 0) {
      setLeftEdge(true)
    } else {
      setLeftEdge(false)
    }
    if (e.target.scrollLeft + e.target.offsetWidth >= e.target.scrollWidth) {
      setRightEdge(false)
    } else {
      setRightEdge(true)
    }
  }

  const scroll = (offset) => {
    filterBar.current.scrollTo({ left: filterBar.current.scrollLeft + offset, behavior: "smooth" })
  }

  const getDealerName = () => {
    return props.site.did?.name
  }

  const applySortOrder = (value) => {
    setSortOrder(value)
    props.listingRef.current.applyFilters({ sort: [value] })
  }
  
  const renderFilter = (item) => {
    
    // { value: 'budget', title: 'Budget' },
    // { value: 'condition', title: 'Vehicle Condition' },
    // { value: 'brands', title: 'Brands' },
    // { value: 'mileage', title: 'Mileage' },
    // { value: 'colors', title: 'Colors' },
    // { value: 'types', title: 'Vehicle Types' },

    if (item == "condition") {
      return <div className={styles.lc} key={item}>
        <div key="condition-1">
          <Button theme={ ["filter", isFilterByCondition('new') ? "filter-on" : "filter"] } href={ props.local ? null : genUrl({ key: 'new' }, isFilterByCondition('new')) } label={'New'} onClick={e => onClick({ condition: ['new'] })}></Button>
        </div>
        { props.facets?.make_name &&
        <div key="condition-2" style={{position:'relative'}}>
          <PreOwnedButton {...props} parentId={'srp_top_filter_bar'}></PreOwnedButton>
        </div>
        }
        {/* <div key="condition-3">
          <Button theme={ ["filter", isFilterByCondition('certified') ? "filter-on" : "filter"] } href={ genUrl({ key: 'certified' }, isFilterByCondition('certified')) } label={'Certified'}></Button>
        </div> */}
      </div>
    } else if (item == "brands" && props.facets?.make_name) {
      return <div key={item}>
        <BrandButton {...props} parentId={'srp_top_filter_bar'}></BrandButton>
      </div>
    } else if (item == "models" && props.facets?.make_name) {
      return <div key={item}>
        <ModelButton {...props} parentId={'srp_top_filter_bar'}></ModelButton>
      </div>
    } else if (item == "mileage" && props.facets?.make_name) {
      return <div key={item}>
        <MileageButton {...props} parentId={'srp_top_filter_bar'}></MileageButton>
      </div>
    } else if (item == "colors" && props.facets?.make_name) {
      return <div key={item}>
        <ColorButton {...props} parentId={'srp_top_filter_bar'}></ColorButton>
      </div>
    } else if (item == "fuel_type" && props.facets?.make_name) {
      return <div key={item}>
        <FuelButton {...props} parentId={'srp_top_filter_bar'}></FuelButton>
      </div>
    }  else if (item == "budget" && !props.hideBudgetButton) {
      return <div key={item}>
        <Button theme={ ["filter", filters.max_price ? "filter-on" : "filter"] } label={'Budget ' + (filters.max_price ? formatCurrency(filters.max_price) : 'None')} onClick={e => props.listingRef.current.toggleBudgetFilter(e)}>
          <div className="flex-column">
            <div>Price Range</div>
            <div className={ 'text-xs text-normal'}>{ filters.max_price ? formatCurrency(filters.max_price) : 'None' }</div>
          </div>
        </Button>
      </div>
    } else if (item == "types") {
        return <div className={styles.lc} key={item + '-items'}>
        { vehTypes.map((item, index) => (
          <div key={'veh-type-' + index}>
            <Button href={ props.local ? null : genUrl(item, isFilterByBodyType(item.key)) } label={item.key} theme={["filter-icon", "filter-icon-wide", (isFilterByBodyType(item.key) ? 'filter-on' : '')]} onClick={e => onClick({ body: [item.key] })}>
              <Icon {...props} name={ item.icon }></Icon>
              <span>{ item.label }</span>
            </Button>
          </div>
        ))}
        { (vehTypes?.length == 0 || props.site.inventory.topFilters.showMoreVehicleTypes) &&
          <div key={item}>
            <VehicleTypeButton {...props} parentId={'srp_top_filter_bar'}></VehicleTypeButton>
          </div>
        }
      </div>
    }
  }
  
  const renderPill = (label, values) => {
    return <Pill theme="white" key={label}>
      <div>
        <div className="flex-col">{ label }</div>
        <button className="flex-col" title="Remove" onClick={e => removeFilter(values)}>
          <Icon {...props} name="x"></Icon>
        </button>
      </div>
    </Pill>
  }
  
  const filterCount = () => {
    let count = 0
    filterPills.map(key => {
      if (key == 'did') {
        if (props.site.did) {
          count += 1
        }
      } else if (filters[key]) {
        if (Array.isArray(filters[key])) {
          count += filters[key].length
        } else {
          count += 1
        }
      }
    })
    return count
  }
  
  const renderFilterPill = (key, values) => {
    if (key == 'condition' && filters.condition) {
      return <>
        { isFilterByCondition('new') &&
          renderPill("New", { key: 'condition', value: 'new' })
        }
        { isFilterByCondition('pre-owned') &&
          renderPill("Pre-owned", { key: 'condition', value: ['pre-owned'] })
        }
        { !isFilterByCondition('pre-owned') && isFilterByCondition('certified') &&
          renderPill("Certified", { key: 'condition', value: 'certified' })
        }
      </>
    } else if (key == 'brand' && filters.brand) {
      return <>
        { filters.brand.map(b => (
          renderPill(b, { key: 'brand', value: b })
        ))}
      </>
    } else if (key == 'model' && filters.model) {
      return renderPill(filters.model, { key: 'model', value: filters.model })
    } else if (key == 'body' && filters.body) {
      return <>
        { filters.body.map(b => (
          renderPill(b, { key: 'body', value: b })
        ))}
      </>
    } else if (key == 'fuel' && filters.fuel) {
      return <>
        { filters.fuel.map(b => (
          renderPill(b, { key: 'fuel', value: b })
        ))}
      </>
    } else if (key == 'year' && filters.year) {
      return <>
        { filters.year.map(b => (
          renderPill(b, { key: 'year', value: b })
        ))}
      </>
    } else if (key == 'color' && filters.color) {
      return <>
        { filters.color.map(b => (
          renderPill(b, { key: 'color', value: b })
        ))}
      </>
    } else if (key == 'term' && filters.term) {
      return renderPill(filters.term, { key: 'term' })
    } else if (key == 'max_miles' && filters.max_miles) {
      return renderPill("< " + formatNumber(filters.max_miles) + ' mi', { key: 'max_miles' })
    } else if (key == 'max_price' && filters.max_price) {
      return renderPill("< " + formatCurrency(filters.max_price), { key: 'max_price' })
    // } else if (key == 'did' && filters.did && props.site.did) {
    //   return renderPill(getDealerName(), { key: 'did' })
    }
  }
  
  return <>
    { !props.site.page?.hide_filters_search_bar && <div id="srp_top_filter_search" className={ styles.c + ' ' + styles.csb + ' max-f-xs' } aria-hidden="true" style={{ zIndex: 20000 }}>
      <div className={ styles.l + ' ' + styles.l_ws + ' ' + styles.l_sb }>
        <div className={styles.l_search}>
          <SearchField id="srp_top_filter_search_term" {...props} parentId={'srp_top_filter_search'} formId="srp_filters_top_search" name=""></SearchField>
        </div>
      </div>
      </div>
    }
    <div className={styles.b}>
      <div id="srp_top_filter_bar" ref={filterBar} className={ styles.c + ' ' + styles.cscroll } onScroll={e => onScroll(e)} onLoad={e => onScroll(e)}>
        <div className={ styles.l + ' ' + styles.l_ws }>
          {/* <div>
            <Button theme={["filter-icon", (filterCount() > 0 ? 'filter-on' : '')]} label="Menu" badge={ filterCount() > 0 } onClick={e => showPills()}>
              <Icon {...props} name="filter"></Icon>
            </Button>
          </div> */}
          { !props.site.page?.hide_filters_search_bar && <div className={styles.l_search + ' min-b-xs'}>
            <SearchField id="srp_top_filter_bar_term" {...props} parentId={'srp_top_filter_bar'} formId="srp_filters_search" name=""></SearchField>
          </div>
          }
          { props.site.inventory.topFilters.items.map((key,index) => (
            <div key={index}>
              { renderFilter(key) }
            </div>
          ))}
          { props.site.page?.hide_filters_search_bar &&
          <div style={{flex: '1 1 auto'}}></div>
          }
          <div className={styles.l_sort + ' min-b-xs'}>
            <Form id="srp_top_filter_sort_form" name="SRP Top Filter Sort">
              <Field type="select" name="sortOrder" style={{ width: '120px'}} value={sortOrder} options={sortOptions} onChange={value => applySortOrder(value)}></Field>
            </Form>
          </div>
        </div>
      </div>
      { !ddVisible && leftEdge &&
      <div className={styles.scb + ' ' + styles.scbl}>
        <Button theme={['icon','filter-scroll']} label={'Scroll Left'} onClick={e => scroll(-100)}>
          <Icon {...props} name="chevron-left"></Icon>
        </Button>
      </div>
      }
      { !ddVisible && rightEdge &&
      <div className={styles.scb + ' ' + styles.scbr}>
        <Button theme={['icon','filter-scroll']} label={'Scroll Right'} onClick={e => scroll(100)}>
          <Icon {...props} name="chevron-right"></Icon>
        </Button>
      </div>
      }
    </div>
    { filterCount() > 0 &&
    <div className={ styles.c + ' ' + styles.cscroll + ' ' + styles.csp }>
      <div className={ styles.l }>
        { filterPills.map((key,index) => (
          filters[key] ? <span key={index} className={styles.fpg}>{ renderFilterPill(key) }</span> : null
        ))}
      </div>
    </div>
    }
    </>

}